export default class Game {
  cardNumbers = Array.from(Array(12), (value, key) => key + 1);
  cardJokers = 16;
  cardColors = new Array('red', 'yellow', 'green', 'blue');

  constructor() {
    if (Game.instance) {
      return Game.instance;
    }
    Game.instance = this;
    return this;
  }

  init(setup) {
    const playersArray = [];
    let playingCardsArray = [];

    for (let i = 1; i <= setup.players; i++) {
      playersArray.push({
        id: i,
        name: `Player ${i}`,
        putAway: new Array(new Array(), new Array(), new Array(), new Array()),
        inHand: new Array(5),
        stock: new Array(),
        active: false
      });
    }

    playersArray[0].active = true;

    if (setup.dfficulty === 'difficult') {
      playingCardsArray = this.shuffle(
        this.generatePlayingCards(true, setup.jokers)
      );
    } else {
      playingCardsArray = this.shuffle(
        this.generatePlayingCards(false, setup.jokers)
      );
    }

    const { players, playingCards } = this.handout(
      playersArray,
      playingCardsArray
    );

    return {
      players,
      playingCards
    };
  }

  generatePlayingCards(difficult, joker) {
    let cardKey = 1;
    const cards = new Array();

    let cardSets = 3;
    let cardJokerSets = this.cardJokers;

    if (difficult) {
      cardSets *= 2;
      cardJokerSets *= 2;
    }

    for (const color of this.cardColors) {
      for (let i = 1; i <= cardSets; i++) {
        for (const number of this.cardNumbers) {
          cards.push({
            key: cardKey,
            color: color,
            number: number,
            joker: false
          });
          cardKey += 1;
        }
      }
    }

    if (joker) {
      for (let i = 1; i <= cardJokerSets; i++) {
        cards.push({
          key: cardKey,
          color: null,
          number: null,
          joker: true
        });
        cardKey += 1;
      }
    }

    return cards;
  }

  playerPositions(players) {
    players[0].position = 's';
    switch (players.length) {
      case 2:
        players[1].position = 'n';
        break;
      case 3:
        players[1].position = 'w';
        players[2].position = 'n';
        break;
      case 4:
        players[1].position = 'w';
        players[2].position = 'n';
        players[3].position = 'o';
        break;
      default:
        break;
    }

    return players;
  }

  /**
   * Randomly shuffle an array
   * https://stackoverflow.com/a/2450976/1293256
   * @param  {Array} cards
   * @return {Array}
   */
  shuffle(cards) {
    let currentIndex = cards.length;
    let temporaryValue, randomIndex;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = cards[currentIndex];
      cards[currentIndex] = cards[randomIndex];
      cards[randomIndex] = temporaryValue;
    }

    return cards;
  }

  handout(players, playingCards) {
    for (let i = 1; i <= 30; i++) {
      for (let player of players) {
        const playingCard = { ...playingCards[playingCards.length - 1] };
        player.stock.push(playingCard);
        playingCards.pop();
      }
    }

    for (let player of players) {
      player.inHand = [...player.stock.splice(player.stock.length - 5)];
    }

    return {
      players,
      playingCards
    };
  }
}
